export default "__VITE_ASSET__CNqYSa_c__"